type ProductApiItem = {
  data?: {
    product?: {
      key?: string;
      title?: string;
      visible?: boolean;
      cta?: Array<{
        heroSection?: {
          key?: string;
          type?: string;
          title?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          primaryButton?: {
            key?: string;
            label?: string;
            visible?: boolean;
          };
        };
        contactSection?: {
          key?: string;
          type?: string;
          label?: string;
          title?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          description?: string;
          lists?: Array<{
            id?: number;
            title?: string;
            imgAlt?: string;
            imgIco?: string;
            buttonLabel?: string;
            description?: string;
          }>;
        };
        productSection?: {
          key?: string;
          type?: string;
          label?: string;
          title?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          description?: string;
          lists?: Array<{
            id?: number;
            img?: string;
            title?: string;
            imgAlt?: string;
            description?: string;
            items?: Array<{
              id?: number;
              Icon?: string;
              label?: string;
              iconAlt?: string;
            }>;
          }>;
        };
      }>;
    };
  };
};

export type NormalizedProduct = {
  page: "product";
  title: string;
  visible: boolean;

  hero: {
    title: string;
    visible: boolean;
    primaryButton: {
      label: string;
      visible: boolean;
    };
  };

  contact: {
    visible: boolean;
    label: string;
    title: string;
    description: string;
    items: Array<{
      id: number;
      title: string;
      imgAlt: string;
      imgIco: string;
      buttonLabel: string;
      description: string;
    }>;
  };

  productSection: {
    visible: boolean;
    label: string;
    title: string;
    description: string;
    items: Array<{
      id: number;
      img: string;
      title: string;
      imgAlt: string;
      description: string;
      features: Array<{
        id: number;
        icon: string;
        label: string;
        iconAlt: string;
      }>;
    }>;
  };

  meta: {
    key: string;
  };
};

export function normalizeProduct(item: ProductApiItem): NormalizedProduct | null {
  const product = item?.data?.product;
  const cta = product?.cta?.[0];

  const hero = cta?.heroSection;
  const contact = cta?.contactSection;
  const productSection = cta?.productSection;

  if (!product || !cta) return null;

  return {
    page: "product",
    title: product.title ?? "",
    visible: Boolean(product.visible),

    hero: {
      title: hero?.title ?? "",
      visible: Boolean(hero?.visible),
      primaryButton: {
        label: hero?.primaryButton?.label ?? "",
        visible: Boolean(hero?.primaryButton?.visible),
      },
    },

    contact: {
      visible: Boolean(contact?.visible),
      label: contact?.label ?? "",
      title: contact?.title ?? "",
      description: contact?.description ?? "",
      items: (contact?.lists ?? []).map((entry) => ({
        id: Number(entry.id ?? 0),
        title: entry.title ?? "",
        imgAlt: entry.imgAlt ?? "",
        imgIco: entry.imgIco ?? "",
        buttonLabel: entry.buttonLabel ?? "",
        description: entry.description ?? "",
      })),
    },

    productSection: {
      visible: Boolean(productSection?.visible),
      label: productSection?.label ?? "",
      title: productSection?.title ?? "",
      description: productSection?.description ?? "",
      items: (productSection?.lists ?? []).map((entry) => ({
        id: Number(entry.id ?? 0),
        img: entry.img ?? "",
        title: entry.title ?? "",
        imgAlt: entry.imgAlt ?? "",
        description: entry.description ?? "",
        features: (entry.items ?? []).map((feature) => ({
          id: Number(feature.id ?? 0),
          icon: feature.Icon ?? "",
          label: feature.label ?? "",
          iconAlt: feature.iconAlt ?? "",
        })),
      })),
    },

    meta: {
      key: product.key ?? "",
    },
  };
}